/**
 * Portuguese language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_PT_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'O meu perfil',
    'lvt.menu.tw_profile': 'Perfil TW',
    'lvt.menu.company_profile': 'Perfil da empresa',
    'lvt.menu.my_notifications': 'As minhas notificações',
    'lvt.menu.sign_out': 'Terminar sessão',

    // footer
    'lvt.footer.back_to_top': 'Voltar ao topo',
    'lvt.footer.terms_of_use': 'Termos de Utilização',
    'lvt.footer.privacy_policy': 'Política de Privacidade',
    'lvt.footer.support_information': 'Informação de apoio',
    'lvt.footer.transwide_home': 'Página de entrada da Transwide',
    'lvt.footer.license_nr': 'Licença n.º:',
    'lvt.footer.build_version': 'Versão:',

    // order list columns
    'lvt.order_list.header': 'Lista de pedidos',
    'lvt.order_list.column.shipperCompany': 'Empresa do expedidor',
    'lvt.order_list.column.reference': 'Referência',
    'lvt.order_list.column.status': 'Estado',
    'lvt.order_list.column.statusReason': 'Motivo do estado',
    'lvt.order_list.column.senderCompany': 'Empresa do remetente',
    'lvt.order_list.column.senderZipcode': 'Código postal do remetente',
    'lvt.order_list.column.senderCity': 'Cidade do remetente',
    'lvt.order_list.column.receiverCompany': 'Empresa do destinatário',
    'lvt.order_list.column.receiverZipcode': 'Código postal do destinatário',
    'lvt.order_list.column.receiverCity': 'Cidade do destinatário',
    'lvt.order_list.column.carrierName': 'Nome da transportadora',
    'lvt.order_list.column.plannedPickupEndDate': 'Recolha planeada',
    'lvt.order_list.column.etaPickup': 'ETA no Carregamento',
    'lvt.order_list.column.delayAtPickup': 'Atraso no Carregamento',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Entrega planeada',
    'lvt.order_list.column.etaDelivery': 'ETA na Entrega',
    'lvt.order_list.column.delayAtDelivery': 'Atraso na Entrega',
    'lvt.order_list.column.timestamps': 'Marca temporal',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Pedido',
    'lvt.order_list.status.failed': 'Erro',
    'lvt.order_list.status.waiting': 'Aguardando',
    'lvt.order_list.status.active': 'Ativo',
    'lvt.order_list.status.stopped': 'Erro',
    'lvt.order_list.status.completed': 'Concluído',
    'lvt.order_list.status.cancelled': 'Cancelado',
    'lvt.order_list.status.timeout': 'Interrompido',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Transportadora não atribuída',
    'lvt.order_list.status_reason.plate_number_not_present': 'A matrícula não está preenchida',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Matrícula não reconhecida',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Matrícula inoperacional',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'linhas por página',
    'lvt.order_list.pagination.first': 'Primeira',
    'lvt.order_list.pagination.previous': 'Anterior',
    'lvt.order_list.pagination.next': 'Seguinte',
    'lvt.order_list.pagination.last': 'Última',
    'lvt.order_list.pagination.no_orders_found': 'Nenhum pedido encontrado',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Reboque',
    'lvt.map.tracked_device.tractor': 'Trator',
    'lvt.map.tracked_device.mobile': 'Telemóvel',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Abrir Lista de pedidos',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Carregamento',
    'lvt.map.pickup_popup.date': 'Data',
    'lvt.map.pickup_popup.address': 'Endereço',
    'lvt.map.delivery_popup.delivery': 'Entrega',
    'lvt.map.delivery_popup.date': 'Data',
    'lvt.map.delivery_popup.address': 'Endereço',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'Em trânsito para entrega',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'Em trânsito para carregamento',
    'lvt.map.current_gps_popup.current_speed': 'Velocidade atual',
    'lvt.map.current_gps_popup.average_speed': 'Velocidade média',
    'lvt.map.current_gps_popup.last_location_update': 'Última atualização da localização',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Hora prevista',
    'lvt.map.current_gps_popup.arrival_delay': 'Atraso na chegada',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Chegou à origem',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Não chegou à origem',
    'lvt.order_list.timestamp.left_origin': 'Partiu da origem',
    'lvt.order_list.timestamp.not_left_origin': 'Não partiu da origem',
    'lvt.order_list.timestamp.arrived_at_destination': 'Chegou ao destino',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Não chegou ao destino',
    'lvt.order_list.timestamp.left_destination': 'Partiu do destino',
    'lvt.order_list.timestamp.not_left_destination': 'Não partiu do destino',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-pt.ts